<template>
    <div :class="`${wrapperClass} custom-checkbox`">
        <PrettyCheck
            class="p-svg p-curve p-pulse p-fill"
            :checked="modelItem ? true : false"
            @change="handleCheck"
            :disabled="isDisabled"
            v-model="modelItem"
            :validateAs="validateAs"
            :name="modelName"
            :validationRules="validationRules"
        >
            <img
                slot="extra"
                class="svg"
                src="/img/check.svg"
            >
            <slot>
                {{label}}
            </slot>
        </PrettyCheck>
        <InlineError
            :errors="errors"
            :type="modelName"
            v-if="validate"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import PrettyCheck from './PrettyCheckClone';
import InlineError from './Forms/InlineError';

export default {
    name: 'CustomCheckbox',
    inject: ['$validator'],
    props: {
        wrapperClass: {
            type: String,
            default: ''
        },
        label: {
            type: String
        },
        module: {
            type: String,
            required: true
        },
        modelName: {
            type: String,
            required: true
        },
        changeHandler: {
            type: Function,
            default: e => e
        },
        validationRules: {
            type: String,
            default: ''
        },
        disabledCheck: {
            type: Boolean,
            default: false
        },
        validateAs: {
            type: String,
            default: ''
        },
        validate: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleCheck: function (e) {
            this.changeHandler(e, this.modelName);
        }
    },
    computed: {
        ...mapState(['formSubmitting']),
        modelItem: {
            get: function () {
                // _.get() Allows us to get nested property values with dot notation
                return _.get(this.$store.state[this.module], this.modelName);
            },
            set: function (val) {
                // @devtodo - either check if the mutation exists or allow a flag that allows you to skip this bit, purely because the changeHandler passed through might handle any value updating.
                if (this.modelName.split('.').length < 2) {
                    this.$store.commit(`${this.module}/${this.modelName}`, val);
                } else {
                    let spl = this.modelName.split('.');
                    let target = spl[spl.length - 1];
                    this.$store.commit(`${this.module}/${target}`, val);
                }
            }
        },
        modelNameToMethod: function () {
            return this.modelName
                .split('_')
                .map(
                    (item, ind) =>
                        ind !== 0 ? item[0].toUpperCase() + item.slice(1) : item
                )
                .join('');
        },
        isDisabled() {
            return this.disabledCheck || this.$store.state.formSubmitting;
        }
    },
    components: {
        PrettyCheck,
        InlineError
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/Checkbox.vue